/** 对外法律文档统一主体与联系方式（隐私政策、法律声明等） */
export const legalEntityInfo = {
  operatorName: '上海魔法向量网络有限公司',
  operatorShortName: '魔法向量',
  registeredAddress: '上海市浦东新区新场镇新环西路860号3幢一层104室',
  privacyEmail: 'superthem@163.com',
  platformScope:
    'www.yuanling.com、www.superthem.com、圆领APP（人才端/企业端）、圆领卖家版APP及相关应用程序',
} as const;

export const privacyPolicyContactParagraph = `如您对本政策或个人信息处理有任何疑问、意见或投诉，可通过以下方式联系我们，我们将在15个工作日内回复：
个人信息处理者：${legalEntityInfo.operatorName}
注册地址：${legalEntityInfo.registeredAddress}
隐私保护专用邮箱：${legalEntityInfo.privacyEmail}
您也可通过圆领APP或圆领卖家版APP内「我的」-「联系客服」与我们联系。`;
